import {FormBuilderOptions} from "FormBuilder/Core/FormBuilder.options";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {FBColumnOptions} from "FormBuilder/Core/FBColumn.Options";

import {FieldAdded} from "ProductFieldBuilder/Events/FieldAdded";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBFieldBase} from "FormBuilder/Fields/Core/FBFieldBase";

import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";

import {FBRow} from "FormBuilder/Core/FBRow";
import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FBGroupPanelModel} from "../../Pro/Fields/Fields/FBGroupPanel/FBGroupPanel.Model";
import {FieldFactory} from "FormBuilder/FieldFactory";
import {ProductData} from "FormBuilder/Core/FormBuilder";
import {ModelSerialize} from "FormBuilder/Core/Models/ModelBase";
import * as React from "react";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {SingleEvent} from "shared/core/Events/SingleEvent";
import {PublishOnceEvent} from "shared/core/Events/PublishOnceEvent";
import {EventManager} from "shared/core/Events/EventManager";
import {LoadExtensionOptions} from "FormBuilder/Events/LoadExtensionOptions";
import {FieldContainerManagerBase} from "FormBuilder/Core/FieldContainerManager/FieldContainerManagerBase";


export class FormBuilderModel extends ModelWithParent<FormBuilderOptions,any> implements ContainerDataRetriever{
    @ModelSerialize()
    public Rows:FBRowModel[];

    public Parent:any;
    public ContainerManager:FieldContainerManagerBase<FormBuilderModel>;

    FieldValueChanged: SingleEvent<FBFieldBaseModel>;
    IsField: boolean;
    IsLoaded: boolean;
    OnLoad: PublishOnceEvent;

    PriceManager: PriceManager;
    ProductPriceChanged: SingleEvent;

    VariationChanged: SingleEvent;
    public ProductOptions:{
        IsVariable:string;
        URL:string;
        Variations:{
            Attributes:any;
            Variations:{
                price:string;
                variation_id:string;
                sale_price:string;
            }[]
        }
    }

    public IsDesign():boolean{
        return false;
    }

    constructor(Options: FormBuilderOptions, Parent: any,public Product:ProductData,public PreviousData:any=null,productOptions:any=null) {
        super(Options, Parent);
        this.ProductOptions=productOptions;
        this.ContainerManager=new FieldContainerManagerBase(this);
        this.ProductPriceChanged=new SingleEvent();
        this.PriceManager=new PriceManager(this);
        FieldContainerManagerBase.LastFieldId=0;
        this.Rows=[];
        this.VariationChanged=new SingleEvent();
        this.FieldValueChanged=new SingleEvent();
        this.IsField=false;


        this.OnLoad=new PublishOnceEvent();
        this.IsLoaded=false;
        for(let row of Options.Rows)
        {
            this.Rows.push(new FBRowModel(row,this))
        }

        FieldContainerManagerBase.LastFieldId=this.ContainerManager.GetFields(true).reduce((prev,current)=>Math.max(prev,current.Options.Id),0);
    }

    public Initialize(){
        this.ContainerManager.GetFields().forEach(x=>x.InitializeConditions());
        EventManager.Publish(new LoadExtensionOptions(this));
        return this;
    }

    public GetIcon(name:string)
    {
        return this.Options.Icons.find(x=>x.Name==name);

    }



    public ExecuteFirstCalculation(){
        this.ContainerManager.GetFields().forEach(field=>{
            if(field instanceof FBFieldWithPriceBaseModel)
            {
                if((field as any).ExecuteFirstCalculation!=null)
                    (field as any).ExecuteFirstCalculation();


                let fieldCalculator=field as FBFieldWithPriceBaseModel;
                if(!fieldCalculator.calculator.GetDependsOnOtherFields())
                {
                    fieldCalculator.calculator.ExecuteAndUpdate();
                }

                if(fieldCalculator.calculator.GetDependsOnOtherFields())
                {
                    fieldCalculator.calculator.ExecuteAndUpdate();
                }
            }
        })
    }



    public CreateRow(options:FBRowModel,index:number)
    {
        return <FBRow key={options.Columns[0].Field.Options.Id} Model={options}/>;
    }


    public CreateSubRow(options:FBRowModel)
    {
        return <FBRow  key={options.Columns[0].Field.Options.Id} Model={options}/>;
    }

    DeleteField(field: FBFieldBaseModel) {
        let row=FBRowOptions;
        for(let currentRow of this.Rows)
        {
            if(currentRow.Columns.find(x=>x.Field==field)!=null)
            {
                this.Rows.splice(this.Rows.indexOf(currentRow),1);
                this.Refresh();
            }
        }
    }










    public GetProductPrice(){
        if(this.ProductOptions.IsVariable=='1')
        {
            let selectedVariable=this.GetSelectedVariable();
            if(selectedVariable==null)
                return 0;
            return selectedVariable.price;
        }
        return this.Product.Price;
    }


    public get FormBuilder():ContainerDataRetriever{
        return null;
    }



/*
    private InternalGetFieldById(fieldId:number,container:ContainerDataRetriever): FBRowModel {
        for(let row of container.ContainerManager.GetRows())
        {
            if(row.Columns[0].Field.Options.Id==fieldId)
                return row;

            if(row.Columns[0].Field.Options.IsFieldContainer)
            {
                let rowReturned=this.InternalGetFieldById(fieldId,row.Columns[0].Field as FBGroupPanelModel);
                if(rowReturned!=null)
                    return rowReturned;
            }

        }

        return null;
    }*/



    GetRuler(): any {
    }



    public GetSalePrice(){
        if(this.ProductOptions.IsVariable=='1')
        {
            let selectedVariable=this.GetSelectedVariable();
            if(selectedVariable==null)
                return 0;
            return selectedVariable.sale_price;
        }
        return this.Product.SalePrice;
    }

    public GetSelectedVariable(){
        let variation=document.getElementsByName('variation_id');
        if(variation.length==0)
            return null;

        let variationId=(variation[0] as HTMLInputElement).value;
        return this.ProductOptions.Variations.Variations.find(x=>x.variation_id==variationId);

    }

    GetVariationValue(VariationName: string) {
        return (document.querySelector('#'+VariationName.toLowerCase()) as HTMLSelectElement).value;
    }


    private SetLastFieldId(Rows: FBRowModel[]) {
        for(let currentRow of Rows)
            for(let currentColumn of currentRow.Columns)
            {
                FieldContainerManagerBase.LastFieldId=Math.max(FieldContainerManagerBase.LastFieldId,currentColumn.Field.Options.Id);

                if(currentColumn.Field.Options.Type==FieldTypeEnum.Repeater||currentColumn.Field.Options.Type==FieldTypeEnum.GroupPanel)
                    this.SetLastFieldId((currentColumn.Field as any).Rows);
            }

    }

    GetId(): string {
        return null;
    }

    GetPluginURL(): any {
        return this.ProductOptions.URL;
    }

}



export interface ContainerDataRetriever {
    Rows:FBRowModel[];
    ContainerManager:FieldContainerManagerBase<any>;
    PreviousData:any;

    FormBuilder:ContainerDataRetriever;
    IsLoaded:boolean;
    OnLoad:PublishOnceEvent;
    PriceManager:PriceManager;
    GetVariationValue(VariationName:string);
    VariationChanged:SingleEvent;
    ProductPriceChanged:SingleEvent;
    GetProductPrice():any;
    GetSalePrice():any;
    Refresh();
    GetRuler():any;
    DeleteField(field:FBFieldBaseModel);
    IsField:boolean;
    CreateSubRow(options:FBRowModel);
    FieldValueChanged:SingleEvent<FBFieldBaseModel>;
    ExecuteFirstCalculation();
    GetId(): string;
    GetPluginURL(): any;
}


declare let ProductBuilderOptions:{
    Options:FormBuilderOptions,
    WCCurrency:any,

    Translations:{Id:number,SubId:string,Value:string}[];
    Product:ProductData;
    PreviousData:any[];

};